import React, { Fragment } from 'react';
import { throttle } from 'throttle-debounce';
import render from '../render';
import { PageFullScreen as Page } from '../../component/Page';
import { articlesDetail as articlesDetailService } from '../../service/articles';
import { CoverPlan } from './CoverPlan';
import { Title } from './Title';
import Author from './Author';
import Bar from './Bar';
import { Content, NoContent } from './Content';
import BackToHome from './BackToHome';
import Recommendation from './Recommendation';
import './GoodsList';
import { setTitle, onPageShow } from '../../native';
import { imgUrlTransform } from '../../util-lib/image/index';
import * as Toast from '../../component/Toast';
import * as lazyload from '../../util-lib/image/lazyload';
import Share, { getShareTipsContent } from '../../component/Share';
import * as Service from '../../service/innovation-discount-headline';
import { isInElementViewport } from '../../util-lib/dom';
import { isLogin, gotoLogin, handleLogin } from '../../util-lib/login/login-controller';
import { push } from '../../util-lib/navigation';
import { sa } from '../../util-lib/statistics';
import './styles.scss';

const UNAVAILABLE_TEXT = '内容已不存在';

function getArticleId() {
  return parseInt(window.__PAGE_DATA.articleId, 10);
}

const { isHeadline = false } = window.__PAGE_DATA;
const saObjType = isHeadline ? 'yh-detail' : 'article';
const startTime = Date.now();

class Article extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      image: '',
      content: '',
      author: null,
      isAvailable: true,
      articleId: getArticleId(),
      shareCount: 0,
      viewCount: 0,
      likeCount: 0,
      isLiked: false,
      publishTime: 0,
      directUrl: null,
      recommendArticles: [],
      shareConfig: {},
      highlight: '',
      disclaimer: ''
    };
    this.$articleContainer = null;
    this.$bottomIndicator = null;
  }

  componentDidMount() {
    const { articleId } = this.state;
    articlesDetailService({
      articleId
    }).then((res) => {
      if (Array.isArray(res) && res.length === 0) {
        this.setState({
          isAvailable: false,
          title: UNAVAILABLE_TEXT
        });
        return;
      }
      const {
        title, image, content, userInfo, shareCount, reviewCount,
        publishTime, directUrl, share, status, // 0 上架 1 下架
        recommendArticles, likes, liked,
        highlight, disclaimer
      } = res;
      const isAvailable = status === 0;
      if (!isAvailable) {
        this.setState({
          isAvailable: false,
          title: UNAVAILABLE_TEXT
        });
        return;
      }
      setTitle(title);
      this.setState({
        title,
        image: imgUrlTransform(image, { both: '750x560' }),
        content,
        author: userInfo,
        shareCount,
        viewCount: reviewCount + 1, // 手动加 1 营造一种实时更新的感觉
        likeCount: likes,
        isLiked: liked,
        publishTime: Number(publishTime),
        directUrl,
        recommendArticles,
        shareConfig: {
          shareTitle: share.title,
          shareContent: share.desc,
          shareUrl: share.url,
          shareImg: share.imageUrl
        },
        highlight,
        disclaimer
      }, () => {
        this.initShare();
        lazyload.customScrollInit('.component-page-full-screen-body', '/fw/750');
      });
      if (isHeadline) {
        this.headlineSetup();
      }
    }).catch((err) => {
      Toast.show({
        content: err.errorMessage
      });
    });

    this.bindLoginSuccess();

    sa.track('page_view', {
      obj_type: saObjType,
      id: getArticleId()
    });
  }

  bindLoginSuccess = () => {
    handleLogin(() => {
      push(window.location.href, {
        ZZCAppArg: 'SelfOpenPage'
      }, true);
    });
  }

  bindPageShow = () => {
    onPageShow(this.update);
  }

  initShare = () => {
    const { articleId, shareConfig } = this.state;
    this.shareInstance = new Share({
      ...shareConfig,
      onSuccess: () => {
        Service.addShareCount({
          articleId
        }).then(console.log);
      },
      shareTipsContent: getShareTipsContent('article')
    });
  }

  /**
   * 头条文章的额外处理
   */
  headlineSetup = () => {
    this.bindPageShow();
    this.$articleContainer = document.querySelector('.component-page-full-screen-body');
    this.$bottomIndicator = document.getElementById('J-bottom-indicator');
    const handleScroll = throttle(500, this.handleWindowScroll);
    if (this.$articleContainer && this.$bottomIndicator) {
      this.$articleContainer.addEventListener('scroll', handleScroll);
      handleScroll();
    }
    window.addEventListener('beforeunload', () => {
      const now = Date.now();
      const time = window.performance
        ? now - window.performance.domComplete
        : now - startTime;
      sa.track('click', {
        obj_type: saObjType,
        obj_id: 'stay-duration',
        id: getArticleId(),
        time: time || 0
      });
    });
  }

  /**
   * 用户浏览到页面最后一屏埋点
   */
  trackUserAccessTheBottomOfThePage = () => {
    if (!this.$bottomIndicator) {
      return;
    }
    if (isInElementViewport(this.$bottomIndicator, this.$articleContainer, 10)) {
      sa.track('click', {
        obj_type: saObjType,
        obj_id: 'access-last-page',
        id: getArticleId()
      });
    }
  }

  handleWindowScroll = () => {
    this.trackUserAccessTheBottomOfThePage();
  }

  handleShare = (config, articleId) => {
    this.shareInstance.toShare({
      ...config,
      onSuccess: () => {
        Service.addShareCount({
          articleId
        }).then(console.log);
      }
    });
    sa.track('click', {
      obj_type: saObjType,
      obj_id: 'share-button-click',
      id: articleId
    });
  }

  handleShareCurrentArticle = () => {
    const { articleId, shareConfig } = this.state;
    this.handleShare(shareConfig, articleId);
  }

  handleLikeCurrentArticle = () => {
    const { articleId } = this.state;
    this.handleLike(articleId);
  }

  handleUnlikeCurrentArticle = () => {
    const { articleId } = this.state;
    this.handleUnlike(articleId);
  }

  handleLike = (articleId) => {
    if (!isLogin()) {
      gotoLogin();
      return;
    }
    Service.like({
      articleId
    }).then(() => {
      this.updateLikeStatus(articleId, 1);
    }).catch(console.log);
  }

  handleUnlike = (articleId) => {
    if (!isLogin()) {
      gotoLogin();
      return;
    }
    Service.unlike({
      articleId
    }).then(() => {
      this.updateLikeStatus(articleId, -1);
    }).catch(console.log);
  }

  updateLikeStatus = (articleId, count) => {
    const { articleId: currentArticleId, likeCount, recommendArticles } = this.state;
    const isLiked = count > 0;
    if (currentArticleId === articleId) {
      this.setState({
        isLiked,
        likeCount: likeCount + count
      });
      return;
    }

    recommendArticles.forEach((item) => {
      if (item.articleId === articleId) {
        item.liked = isLiked;
        item.likes += count;
      }
    });

    this.setState({
      recommendArticles
    });
  }

  update = () => {
    const { articleId } = this.state;
    articlesDetailService({
      articleId
    }).then((res) => {
      const {
        shareCount, reviewCount, recommendArticles, likes, liked
      } = res;

      this.setState({
        shareCount,
        viewCount: reviewCount,
        likeCount: likes,
        isLiked: liked,
        recommendArticles
      });
    }).catch(console.log);
  }

  render() {
    const {
      title,
      image,
      content,
      author,
      isAvailable,
      publishTime,
      shareCount,
      viewCount,
      likeCount,
      isLiked,
      directUrl,
      recommendArticles,
      highlight,
      disclaimer
    } = this.state;
    const hasContent = !!content;
    return (
      <Page
        id="article"
        defaultNavBar={false}
        defaultNavBarProps={
          {
            title
          }
        }
      >
        {
          isAvailable ? (
            <Fragment>
              {image && <CoverPlan image={image} />}
              <div className="container">
                <div className="article">
                  {!!title && <Title title={title} highlight={highlight} />}
                  {!!author && <Author {...author} publishTime={publishTime} />}
                  {
                  hasContent && (
                    <Content
                      data={content}
                      isHeadline={isHeadline}
                      disclaimer={disclaimer}
                    />
                  )}
                  <div id="J-bottom-indicator" />
                </div>
                {
                  isHeadline && hasContent && (
                    <Recommendation
                      data={recommendArticles}
                      onShare={this.handleShare}
                      onLike={this.handleLike}
                      onUnlike={this.handleUnlike}
                    />
                  )
                }
                {
                  isHeadline && hasContent && (
                    <Bar
                      shareCount={shareCount}
                      viewCount={viewCount}
                      likeCount={likeCount}
                      isLiked={isLiked}
                      directUrl={directUrl}
                      onShare={this.handleShareCurrentArticle}
                      onLike={this.handleLikeCurrentArticle}
                      onUnlike={this.handleUnlikeCurrentArticle}
                    />
                  )
                }
              </div>
              {
                isHeadline && <BackToHome />
              }
            </Fragment>
          ) : (
            <NoContent text={UNAVAILABLE_TEXT} />
          )
        }
      </Page>
    );
  }
}

render(Article);
